import React from "react"
import type { StyleProps } from "@mallardbay/lib-react-components"

import type { QuoteFieldsFragment } from "~graphql/generated/graphql"
import NumericInputWithButtons from "~components/shared/numeric-input-with-buttons"
import COPY from "~config/copy-constants"
import UnorderedList from "~components/shared/todo-lib-react-components/unordered-list"
import {
    TextLargeBold,
    TextSmall,
} from "~components/shared/todo-lib-react-components/text"
import Card from "~components/shared/todo-lib-react-components/card"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly quote: QuoteFieldsFragment
    readonly hostSlots: number
    readonly handleHostSlotsChange: (value: number) => void
}

export default function GroupPaySummary({
    quote,
    hostSlots,
    handleHostSlotsChange,
}: Props) {
    const styles = useStyles()

    if (!quote.payment_group) return null

    const { remaining_slots: remainingSlots } = quote.payment_group

    const maxHostSlots = quote.items.length - 1

    return (
        <Card style={styles.root}>
            <Box style={styles.inputContainer}>
                <div>
                    <TextLargeBold>{COPY.HOW_MANY_GUESTS}</TextLargeBold>
                    <TextSmall>
                        {COPY.REMAINING_SLOTS}: {remainingSlots}
                    </TextSmall>
                </div>
                <NumericInputWithButtons
                    value={hostSlots}
                    setValue={handleHostSlotsChange}
                    minValue={1}
                    maxValue={maxHostSlots}
                />
            </Box>

            <TextLargeBold style={{ marginBottom: 2 }}>
                {COPY.HOW_IT_WORKS}
            </TextLargeBold>
            <UnorderedList items={getHowItWorksListItems()} />
        </Card>
    )
}

function useStyles() {
    const root: StyleProps = {
        marginTop: 6,
    }
    const inputContainer: StyleProps = {
        display: "flex",
        flexDirection: { base: "column", md: "row" },
        justifyContent: { base: "flex-start", md: "space-between" },
        alignItems: { base: "flex-start", md: "center" },
        marginBottom: 8,
    }

    return { root, inputContainer }
}

function getHowItWorksListItems() {
    return [
        COPY.GROUP_PAY_NOTE_ONE,
        COPY.GROUP_PAY_NOTE_TWO,
        COPY.GROUP_PAY_NOTE_THREE,
        `${COPY.GROUP_PAY_NOTE_FOUR}`,
    ]
}
